import InvestorSecondaryMarketBanner from './investor-secondary-market-banner';

export default InvestorSecondaryMarketBanner;
